import Ski from '../assets/images/ski.png';
import Pass from '../assets/images/passkeper.png';
import Jahorina from '../assets/images/jahorina.png';
import MyGym from '../assets/images/mygym.png';
import NovalFlow from '../assets/images/novalflow.png';

export const projectsData = [
  {
    id: 1,
    title: 'Ski Serbia',
    description:
      'Ski Serbia is an application designed to provide users with comprehensive information about skiing resorts, slopes, weather conditions, and other relevant details across various locations in Serbia. It offers a convenient platform for enthusiasts to plan their skiing adventures and stay updated with the latest news and events in the Serbian skiing community.',
    cardDescription: 'Real-time ski resort info, slopes, weather, and lift data across Serbia.',
    imageUrl: Ski,
    playStoreLink: 'https://play.google.com/store/apps/details?id=com.neoapps.skiserbia&hl=en',
    role: 'Design & Development',
    stack: ['Android', 'Kotlin', 'Firebase', 'REST API'],
    outcome: 'Live app covering major Serbian ski resorts with real-time weather, slopes, and lift data.',
  },
  {
    id: 2,
    title: 'My Passkeeper',
    description:
      'My Passkeeper is a secure and intuitive application designed to help users manage and organize their passwords and sensitive data efficiently. With robust encryption and user-friendly features, it offers a seamless experience for storing, generating, and accessing passwords across different platforms.',
    cardDescription: 'Secure password manager with encryption and a clean, intuitive interface.',
    imageUrl: Pass,
    imageClass: 'project__image--passkeeper',
    playStoreLink: 'https://play.google.com/store/apps/details?id=com.flixeron.my_passkeeper&hl=en',
    role: 'Design & Development',
    stack: ['Android', 'Kotlin', 'Encryption', 'Material Design'],
    outcome: 'Secure password manager published on Google Play with a clean, intuitive UX.',
  },
  {
    id: 3,
    title: 'Ski Jahorina',
    description:
      'Ski Jahorina is a user-friendly application for winter sports enthusiasts. It provides real-time updates, slope maps, lift statuses, and event notifications. With essential tools and a seamless design, it enhances your skiing adventures and ensures convenience on the mountain.',
    cardDescription: 'Live slopes, lift status, maps, and event updates for Ski Jahorina.',
    imageUrl: Jahorina,
    playStoreLink: 'https://play.google.com/store/apps/details?id=com.neoapps.skijahorina&hl=en',
    role: 'Design & Development',
    stack: ['Android', 'Kotlin', 'Firebase', 'Google Maps'],
    outcome: 'Dedicated resort app for Jahorina with live mountain conditions and resort info.',
  },
  {
    id: 4,
    title: 'My Gym',
    description:
      'My Gym makes it easy to create custom workouts, log sets, reps, and weights, and track your progress over time. Stay motivated with personal records, achievements, and detailed stats for every workout.',
    cardDescription: 'Workout tracking with custom plans, PRs, achievements, and progress stats.',
    imageUrl: MyGym,
    playStoreLink: 'https://play.google.com/store/apps/details?id=com.neoapps.mygym&hl=en',
    role: 'Design & Development',
    stack: ['Android', 'Kotlin', 'Room', 'Firebase'],
    outcome: 'Fitness tracking app with 1K+ downloads, workout logging, achievements, and progress stats.',
  },
  {
    id: 5,
    title: 'NovalFlow',
    description:
      'NovalFlow is a recruitment pipeline for independent recruiters and small desks. Clients, jobs, candidates, and applications live on one calm board — from sourced to offer — with follow-up reminders attached to each person so nothing slips between calls. Upload PDF or Word CVs and contact details stay on the candidate; no enterprise seats or workspace admin required.',
    cardDescription: 'Recruitment pipeline for solo recruiters — clients, candidates, and follow-ups in one board.',
    imageUrl: NovalFlow,
    imageClass: 'project__image--novalflow',
    websiteLink: 'https://novalflow.com/',
    role: 'Product Design & Full-Stack Development',
    stack: ['React', 'Web App', 'Recruitment SaaS', 'Pipeline'],
    outcome: 'Live SaaS at novalflow.com with Free and Pro plans for independent recruiters.',
  },
];
